<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Уведомления</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="n-name">Заголовок уведомления <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="n-name" v-model="formData.name" placeholder="Введите заголовок">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="n-name">Текст уведомления</label>
                <textarea class="form-control" type="text" id="n-text" v-model="formData.text" placeholder="Введите текст уведомления"></textarea>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-6 mb-3">
                <label for="n-display_at" class="form-label">Дата начала показа</label>
                <input class="form-control" id="n-display_at" type="datetime-local" v-model="formData.display_at">
                <div class="valid-feedback">Успешно</div>
            </div>
            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Дата окончания показа</label>
                <input class="form-control" id="n-hide_at" type="datetime-local" v-model="formData.hide_at">
                <div class="valid-feedback">Ошибка</div>
            </div>
        </div>

        <div class="form-check mb-4">
            <input class="form-check-input" type="checkbox" :checked="formData.pinned" id="n-pinned" v-model="formData.pinned">
            <label class="form-check-label" for="n-pinned">Закрепить?</label>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="updateNotification"/>
            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Notification from "../../../../models/Notification";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "NotificationsEditComponent",
    components: { ConfirmBtn },
    props: {
        route_back: String,
        route_get: String,
        route_update: String,
        notification_id: {
            type: [Number, String],
            default: 0
        }
    },
    data: function () {
        return {
            notification: new Notification({
                route_update: this.route_update,
                route_get: this.route_get
            }),
            formData: {
                name: '',
                text: '',
                display_at: '',
                hide_at: '',
                pinned: false
            }
        }
    },
    methods: {
        ...mapMutations('ui', ['toggleLoading']),
        updateNotification: function () {
            let result = this.notification.update({
                name: this.formData.name,
                text: this.formData.text,
                display_at: this.formData.display_at,
                hide_at: this.formData.hide_at,
                pinned: this.formData.pinned
            }, this.notification_id);
            if(result)
            {
                window.location.href = this.route_back;
            }
            else
            {
                console.log('error: create_notification');
                this.toggleLoading();
            }
        },
        itemGet: async function () {
            let item = await this.notification.get(this.notification_id);
            this.formData.name = item.name;
            this.formData.text = item.text;
            this.formData.display_at = item.display_at;
            this.formData.hide_at = item.hide_at;
            this.formData.pinned = item.pinned;
        }
    },
    mounted() {
        this.itemGet();
    }
}
</script>

<style scoped>

</style>
